module.exports = __webpack_public_path__ + "img/cifrao.1167372f.svg";